/* eslint-disable react/button-has-type */
import PropTypes from 'prop-types';
import { useRef } from 'react';
import styled from 'styled-components';

const Button = ({
  buttonRef,
  children,
  className,
  onClick,
  type = 'button',
  ...props
}) => {
  const ref = useRef();
  if (buttonRef && ref.current) {
    buttonRef(ref.current);
  }

  const handleClick = event => {
    if (ref.current) ref.current.blur();
    if (onClick) onClick(event);
  };

  return (
    <button
      ref={ref}
      type={type}
      className={className}
      onClick={handleClick}
      {...props}
    >
      {children}
    </button>
  );
};

Button.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string.isRequired
};

const getFontSize = ({ size }) => {
  if (size === 'small') {
    return '0.8125rem';
  }

  if (size === 'large') {
    return '0.9375rem';
  }

  return '0.875rem';
};

const getPadding = ({ size }) => {
  if (size === 'small') {
    return '4px 5px';
  }

  if (size === 'large') {
    return '8px 11px';
  }

  return '6px 8px';
};

const StyledButton = styled(Button)`
  align-items: center;
  background-color: transparent;
  border: 0;
  box-sizing: border-box;
  cursor: pointer;
  display: inline-flex;
  font-size: ${getFontSize};
  font-weight: bold;
  justify-content: center;
  line-height: 1.4;
  min-width: 64px;
  outline: 0;
  padding: ${getPadding};
  position: relative;
  text-decoration: none;
  text-transform: uppercase;
  transition: background-color 250ms cubic-bezier(0.4, 0, 0, 2, 1) 0ms;
  user-select: none;
  vertical-align: middle;
`;

export default StyledButton;
